import { __ } from '@wordpress/i18n';
import { Button } from '@wordpress/components';
import { useDispatch, useSelect } from '@wordpress/data';
import { createBlock } from '@wordpress/blocks';
import { plus } from '@wordpress/icons';

import { getDefaultAvatarAttributes } from '../../_shared/default-avatars';

/**
 * Custom appender that inserts a `brandy/avatar` child into the group.
 * Rendered as the last flex item so it sits after the avatar stack without
 * disturbing the overlap layout.
 *
 * The new avatar arrives with a sample face rather than empty, matching the
 * ones the group seeds itself with. The current child count picks which sample,
 * so consecutive adds give different people instead of repeating one face; the
 * list wraps once it runs out.
 */
export default function AvatarAppender({ clientId }) {
  const { insertBlock } = useDispatch('core/block-editor');

  const childCount = useSelect(
    (select) => select('core/block-editor').getBlockCount(clientId),
    [clientId]
  );

  const onAdd = () => {
    insertBlock(
      createBlock('brandy/avatar', getDefaultAvatarAttributes(childCount)),
      undefined,
      clientId
    );
  };

  return (
    <Button
      variant="secondary"
      icon={plus}
      onClick={onAdd}
      className="brandy-avatar-group__appender"
      label={__('Add avatar', 'brandy-blocks')}
      showTooltip
    />
  );
}
